import styled from "styled-components";
import {
    colors,
    fontSizes, 
    fontWeights, 
    spacings,
    borders
} from 'styles/theme';

export const TableCards = styled.div`
  display: flex;
  
  .card{
    margin-right:  ${spacings.lg};
    padding:  ${spacings.md}  ${spacings.ls};
    border: ${borders.xs} solid ${colors.neutral_regular};
    border-radius: ${borders.lg};
    margin-bottom: ${spacings.ls};
    background-color: transparent;
    transition: all 0.2s linear;
    min-width: 150px;

    &.isActive{
      border: ${borders.xs} solid ${colors.primary};
    }

    &:last-child{
      margin-right: 0;
    }

    span{
      font-style: normal;
      font-weight: ${fontWeights.w700};
      font-size: ${fontSizes.xs};
      color: ${colors.neutral_darker};
    }

    
    .data-container{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.25rem;
      
      h2{
        display: inline-block;
        font-family: DM Sans;
        font-style: normal;
        font-weight: ${fontWeights.w700};
        font-size: ${fontSizes.xl};
        color: ${colors.neutral_darkest};
        margin-right: 0.5rem;
      }

      .button-link{
        min-height: 37px;
        height: 37px;
        width: 37px;
      }
    }
  }
`;